import React from 'react';
import { SpacerVertical, Typography } from '@klarna/bubble-ui';
import { CallToActionButton } from '@/components';
import { ContractOnboardingStatus } from '@/bpc/mf-fields/enm/ContractOnboardingStatus';
const styles = {
    outerContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
};
export default function ExitPointsComponent(props) {
    const { status, exitPoints, t, tPrefix, navigateToExitPoint, exitPointTranslationPath } = props;
    if (!exitPoints || !exitPoints.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        status === ContractOnboardingStatus.ONBOARDING_COMPLETED && (React.createElement(CallToActionButton, { onClick: navigateToExitPoint, customOuterContainerStyles: styles.outerContainer }, t(`${tPrefix}.button_text`))),
        exitPointTranslationPath && (React.createElement(Typography, { "data-testid": "exit-point-message", textToken: "text-style/text/super-paragraphs/body/regular" }, t(exitPointTranslationPath))),
        React.createElement(SpacerVertical, { spaceToken: "space.400" })));
}
